/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/*@ngInject*/
export default function AdminController(userService, adminService, types, toast, $scope, $rootScope, $state, $translate) {

    var vm = this;

    vm.$onInit = function () {
        vm.types = types;

        vm.nsVersion = TEKTELIC_NS_VERSION; //eslint-disable-line

        vm.commitHash = COMMITHASH; //eslint-disable-line

        vm.isReadOnly = userService.getAuthority() != types.authority.SYS_ADMIN.value ? true : false;

        vm.save = save;
        vm.sendTestMail = sendTestMail;
        vm.sendTestSms = sendTestSms;

        vm.smtpProtocols = ('smtp smtps').split(' ').map(function (protocol) {
            return protocol;
        });

        vm.smsProvider = types.smsProvider.TWILIO.value;

        loadSettings();
    };

    $translate('admin.test-mail-sent').then(function (translation) {
        vm.testMailSent = translation;
    }, function (translationId) {
        vm.testMailSent = translationId;
    });

    function loadSettings() {
        adminService.getAdminSettings($state.$current.data.key).then(function success(settings) {
            vm.settings = settings;
        });
    }

    function save() {
        adminService.saveAdminSettings(vm.settings).then(function success(settings) {
            vm.settings = settings;
            vm.settingsForm.$setPristine();
        });
    }

    function sendTestMail() {
        adminService.sendTestMail(vm.testMailTo).then(function success() {
            toast.showSuccess($translate.instant('admin.test-mail-sent'));
        });
    }

    function sendTestSms() {
        adminService.sendTestSms(vm.testSmsTo, vm.testSmsBody).then(function success() {
            toast.showSuccess($translate.instant('admin.test-sms-sent'));
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/admin/admin.controller.js